jQuery(document).ready(function ($) {
	var breakpoint_small = 0;
	var breakpoint_medium = 640;
	var breakpoint_large = 1024;
	var breakpoint_xlarge = 1200;
	var breakpoint_xxlarge = 1440;

	// Make space for the fixed positioned footer
	if ($(window).width() >= breakpoint_medium) {
		$('body.style-02 #page-wrapper').css('margin-bottom', Math.floor($('footer#footer').outerHeight()));
        $('body.style-04 #page-wrapper').css('margin-bottom', Math.floor($('footer#footer').outerHeight()));
	}

	// data-sticky-on breakpoint does not appear to work. so let's remove the sticky sidebar feature ourselves for small screens
	// if ($(window).width() < breakpoint_medium) {
	// 	$('#sidebar-inner.sticky').foundation('_destroy');
    //     $('#sidebar-inner').removeClass('sticky');
	// }

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											PRICING TABLE 03
	/////////////////////////////////////////////////////////////////////////////////////////////////

	jQuery('section.pricing-table-03 .pricing-table-switches .switch input').on('change', function (event) {
		var selected = $(this).attr('id');

		$('section.pricing-table-03 .pricing-table-prices .pricing_period')
			.removeClass('hide')
			.removeClass('fadeOutUp')
			.removeClass('fadeInUp');

		$('section.pricing-table-03 .pricing-table-prices .pricing_period').addClass('fadeOutUp');
		$('section.pricing-table-03 .pricing-table-prices .pricing_period_' + selected).addClass('fadeInUp');

	});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//								SMOOTH SCROLL TO CENTER OF ElEMENTS
	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Disable for now, causes more harm than it does good...
	//     jQuery(document).ready(function($)
	//     {
	//         $('a[href^="#"]').on('click', function (e) {

	// 			// Ignore clicks on tabs and accordions
	// 			if (! $(this).parent().hasClass('tabs-title') && ! $(this).hasClass('accordion-title'))
	// 			{
	//				// TODO: check if element exists, if the link is not a jump to anchor, the target element might not even exist...
	// 				e.preventDefault();
	// 				var element = document.getElementById($(this).attr('href').substring(1));
	// 				element.scrollIntoView({behavior: "smooth", block: "center"});
	// 				return false;
	// 			}
	//         });
	//     });

});

